export default __webpack_public_path__ + "static/media/homehero1.57a3cf6e.png";